import PropTypes from 'prop-types';
import React from 'react';

import CancelButton from 'components/buttons/Cancel';
import ConfirmButton from 'components/buttons/Confirm';
import Card from 'components/Card';
import CardActions from 'components/Card/Actions';
import CardHeader from 'components/Card/Header';
import CardText from 'components/Card/Text';
import Dialog from 'components/Dialog';
import HTMLFragment from 'components/HTMLFragment';
import RowSpacer from 'components/RowSpacer';

const styles = {
  card: {},
  cardActions: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  cardActionButton: {
    marginRight: 0,
    minWidth: null,
  },
  dialogBody: {
    padding: 0,
  },
};
const CommunityApplicableEventDialog = ({
  event,
  onConfirm,
  onCancel,
  open,
}) => {
  return (
    <Dialog
      bodyStyle={styles.dialogBody}
      modal
      onRequestClose={onCancel}
      open={open}
    >
      <Card style={styles.card}>
        <CardHeader
          titleStyle={{ fontSize: '1rem !important' }}
          title='Ready to get involved?'
        />
        <CardText noTopPadding>
          <HTMLFragment>
            This community is sponsoring an event you can apply to participate
            in right now! Click below to learn more about {event.name}.
          </HTMLFragment>
        </CardText>
        <CardActions noTopPadding>
          <CancelButton label='Later' secondary onClick={onCancel} />
          <RowSpacer />
          <ConfirmButton label='Sure' primary onClick={onConfirm} />
        </CardActions>
      </Card>
    </Dialog>
  );
};

CommunityApplicableEventDialog.propTypes = {
  event: PropTypes.object.isRequired,
  onCancel: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  open: PropTypes.bool,
};

export default CommunityApplicableEventDialog;
